const getBooleanEnv = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value === undefined || value.trim() === "") {
    return defaultValue;
  }
  const normalizedValue = value.trim().toLowerCase();
  if (normalizedValue === "true") return true;
  if (normalizedValue === "false") return false;

  return defaultValue;
};

export const B2C_FEATURE_FLAGS = {
  isOCEnvironment: getBooleanEnv(import.meta.env.VITE_IS_OC_ENVIRONMENT, false),
  isInsurerShow: getBooleanEnv(import.meta.env.VITE_IS_INSURER_SHOW, true),

  isCarHide: getBooleanEnv(import.meta.env.VITE_IS_CAR_HIDE, false),
  isHomeHide: getBooleanEnv(import.meta.env.VITE_IS_HOME_HIDE, false),
  isTravelHide: getBooleanEnv(import.meta.env.VITE_IS_TRAVEL_HIDE, false),
  isHealthHide: getBooleanEnv(import.meta.env.VITE_IS_HEALTH_HIDE, false),
  isLifeHide: getBooleanEnv(import.meta.env.VITE_IS_LIFE_HIDE, false),

  applyValidation: getBooleanEnv(import.meta.env.VITE_APPLY_VALIDATION, false),
  isLifeHomeContent: getBooleanEnv(import.meta.env.VITE_IS_LIFE_HOME_CONTENT, false),
} as const;
